import MainArea from "../components/MainArea";
import ServicePayment from "../components/ServicePayment";
import ChatHistory from "../components/ChatHistory";
import FrameComponent4 from "../components/FrameComponent4";
import { useNavigate } from "react-router-dom";

const Introduction = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/31-sign-in1");
  };

  return (
    <div
      className="min-h-screen w-full bg-light-primary-key-background overflow-y-auto flex flex-col items-center justify-between px-4 pt-10 pb-[calc(env(safe-area-inset-bottom)+120px)] box-border leading-normal tracking-normal"
    >
      {/* Nội dung chính */}
      <div className="w-full max-w-md flex flex-col gap-10">
        <MainArea />
        <ServicePayment />
        <ChatHistory />
      </div>

      {/* Nút đăng nhập/đăng ký lùi xuống dưới */}
      <div className="w-full max-w-md mt-10">
        <FrameComponent4
          groupDivPadding="20px 114px 20px 115px"
          tiCKVNgViIuKh="Đăng nhập/ Đăng ký nếu chưa đăng nhập"
          tiCWidth="unset"
          tiCDisplay="unset"
          onClickContinue={handleNavigate}
        />
      </div>
    </div>
  );
};

export default Introduction;